import { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import assetPath from '../utils/assetPath';

const navItems = [
  { label: 'Home', to: '/' },
  { label: 'Members', to: '/members' },
  { label: 'Videos', to: '/videos' },
  { label: 'Merch', to: '/merch' },
  { label: 'Contact', to: '/contact' },
];

const ControlCluster = ({ language, toggleLanguage, theme, toggleTheme, className = '' }) => (
  <div className={`control-cluster ${className}`.trim()}>
    <button
      className="icon-button"
      type="button"
      onClick={toggleLanguage}
      aria-label="Switch language"
      aria-pressed={language === 'fr'}
    >
      <span aria-hidden="true">🌐</span>
      <span className="icon-label">{language.toUpperCase()}</span>
    </button>
    <button
      className="icon-button"
      type="button"
      onClick={toggleTheme}
      aria-label="Toggle color theme"
      aria-pressed={theme === 'light'}
    >
      <span aria-hidden="true">{theme === 'dark' ? '🌙' : '☀️'}</span>
    </button>
  </div>
);

const SearchBar = ({ className = '' }) => {
  const handleSubmit = (event) => {
    event.preventDefault();
  };

  return (
    <form className={`nav-search ${className}`.trim()} role="search" onSubmit={handleSubmit}>
      <span className="nav-search-icon" aria-hidden="true">
        🔍
      </span>
      <input type="search" placeholder="Search" aria-label="Search site" autoComplete="off" />
    </form>
  );
};

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { language, toggleLanguage, theme, toggleTheme } = useAppContext();
  const mid = Math.ceil(navItems.length / 2);
  const leftNav = navItems.slice(0, mid);
  const rightNav = navItems.slice(mid);

  useEffect(() => {
    setOpen(false);
  }, [location]);

  const renderNavList = (items, className = '') => (
    <ul className={`nav-links ${className}`.trim()}>
      {items.map((item) => (
        <li key={item.to}>
          <NavLink to={item.to} end className={({ isActive }) => (isActive ? 'active' : undefined)}>
            {item.label}
          </NavLink>
        </li>
      ))}
    </ul>
  );

  const mobileMenuId = 'navbar-mobile-menu';

  return (
    <nav className={`navbar ${open ? 'is-open' : ''}`}>
      <div className="nav-content">
        <SearchBar className="desktop-only nav-search-left" />
        {renderNavList(leftNav, 'nav-links-left')}
        <Link to="/" className="logo-wrap">
          <img src={assetPath('/assets/logo-salty.png')} alt="SΛLTY team logo" />
          <span>SΛLTY</span>
        </Link>
        {renderNavList(rightNav, 'nav-links-right')}
        <ControlCluster
          language={language}
          toggleLanguage={toggleLanguage}
          theme={theme}
          toggleTheme={toggleTheme}
          className="desktop-only"
        />
        <button
          className="menu-toggle"
          aria-label="Toggle navigation"
          aria-expanded={open}
          aria-controls={mobileMenuId}
          onClick={() => setOpen((prev) => !prev)}
        >
          ☰
        </button>
      </div>
      <div className={`mobile-menu ${open ? 'open' : ''}`} id={mobileMenuId}>
        <SearchBar className="mobile-only" />
        <div className="mobile-nav-links">{renderNavList(navItems)}</div>
        <ControlCluster
          language={language}
          toggleLanguage={toggleLanguage}
          theme={theme}
          toggleTheme={toggleTheme}
          className="mobile-only"
        />
      </div>
    </nav>
  );
};

export default Navbar;
